export type ParseBooleanProps = {
  string: string;
};

export const parseBoolean = ({ string }: ParseBooleanProps) =>
  string === "true";
